import { createSelector } from 'reselect';
import { arrayUniqBy } from '../helpers/immutable/array';
const statePolicySelector = (state) => state.policy;

export const agencySelector = createSelector(
    [statePolicySelector],
    (policy) => {
        const agencies = arrayUniqBy(policy.items.map(policy=> {return {...policy.agency,policies:[]}; }), 'agencyCode');
        for(let i in policy.items){            
            let p = policy.items[i];
            if (p.agency){
                let agency = agencies.find(a=> a.agencyCode === p.agency.agencyCode);
                if (agency)
                    agency.policies.push(p);
            }                
        }        
        return { agencies };
    }
);